import reducer from './reducer'

import * as tradeDetailSelectors from './selectors'

export { tradeDetailSelectors }

export default reducer
